export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="border-b border-slate-200 bg-white">
      <div className="px-8 py-6 flex flex-wrap gap-4 items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-ps-blue font-semibold">{subtitle}</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight mt-1 text-ps-deep" data-testid="page-title">{title}</h1>
        </div>
        {action}
      </div>
    </div>
  );
}
